'use client';

import Header from '@/components/Header';
import ProjectNavigation from '@/components/ProjectNavigation';
import DashboardLayout from '@/components/DashboardLayout';
import ProjectLayout from '@/components/ProjectLayout';
import AuthGuard from '@/components/AuthGuard';
import ErrorBoundary from '@/components/ErrorBoundary';
import { ProjectProvider, useProject } from '@/contexts/ProjectContext';

function MainContent() {
  const { selectedDashboard, selectedProject } = useProject();

  // Render dashboard layout if dashboard is selected
  if (selectedDashboard) {
    return <DashboardLayout />;
  }

  // Render project layout if project is selected
  if (selectedProject) {
    return <ProjectLayout />;
  }

  // Default: show message to select something
  return (
    <div className="flex-1 p-6 flex items-center justify-center">
      <div className="text-gray-400 text-sm">Select a project or dashboard to get started</div>
    </div>
  );
}

export default function Home() {
  return (
    <AuthGuard>
      <ProjectProvider>
        <div className="h-screen flex flex-col">
          <Header />
          <ProjectNavigation />
          <ErrorBoundary>
            <MainContent />
          </ErrorBoundary>
        </div>
      </ProjectProvider>
    </AuthGuard>
  );
}

